var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheckOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 22H3.34375C2.04933 22 1 20.8807 1 19.5C1 15.4193 6.625 15.5 8.5 15.5C10.375 15.5 16 15.4193 16 19.5C16 20.8807 14.9507 22 13.6562 22Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.9999C10.5711 11.9999 12.25 10.2091 12.25 7.99997C12.25 5.79085 10.5711 4 8.5 4C6.42893 4 4.75 5.79085 4.75 7.99997C4.75 10.2091 6.42893 11.9999 8.5 11.9999Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7128_229683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 4.66667H21.3333M17.6667 6.5H19.9583M15.375 5.58333C15.375 3.1299 16.3456 2.375 19.5 2.375C22.6544 2.375 23.625 3.1299 23.625 5.58333C23.625 8.03676 22.6544 8.79167 19.5 8.79167C19.3438 8.79167 19.193 8.78982 19.0473 8.786L17.2083 10.625V8.55972C15.8484 8.18172 15.375 7.29672 15.375 5.58333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7128_229683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "currentColor",
    transform: "translate(14 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheckOutlined);
export default __webpack_public_path__ + "static/media/user-check-outlined.b4871570f14df026cc87372841155b64.svg";
export { ForwardRef as ReactComponent };